import { List } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekList = styled(List)(({ theme }) => ({}));

export { PeekList, PeekList as default };
